import ButtonThemeTextLink from '@/src/components/Modules-revamp/ImageAndPoster/ButtonThemeTextLink';
import EffectSelect from '@/src/components/Modules-revamp/ImageAndPoster/EffectSelect';
import ImageLink from '@/src/components/Modules-revamp/ImageAndPoster/ImageLink';
import ImageWidth from '@/src/components/Modules-revamp/ImageAndPoster/ImageWidth';
import LayerType from '@/src/components/Modules-revamp/ImageAndPoster/LayerType';
import PositionOption from '@/src/components/Modules-revamp/ImageAndPoster/PositionOption';
import LayerText from '@/src/components/Modules-revamp/ImageAndPoster/Text';
import { LayerProps, LayerTemplate } from '@/src/strategies/render/layer';
import { LayerField } from '@/src/strategies/util';
import React from 'react';
import {
  validateImageLayer,
  validateButtonLayer,
} from 'src/constrains/SalesChannelContent-Revamp/ModuleList/validator';

function leftComponent(i: LayerProps, extra: any) {
  const { buttons, breakpoint } = extra;

  switch (i?.field) {
    case LayerField.LayerType: {
      return <LayerType options={i?.options || []} />;
    }
    case LayerField.Image: {
      const { checkButtonLayerImage, checkButtonLayerLink } =
        validateImageLayer();
      return (
        <ImageLink
          breakpoint={breakpoint}
          validators={{
            image: checkButtonLayerImage,
            link: checkButtonLayerLink,
          }}
        />
      );
    }
    case LayerField.ImageWidth: {
      return <ImageWidth breakpoint={breakpoint} />;
    }
    case LayerField.ButtonTheme: {
      const {
        checkButtonLayerLink,
        checkButtonLayerButtonText,
        checkButtonLayerButtonThemeUuid,
      } = validateButtonLayer();
      return (
        <ButtonThemeTextLink
          themeOptions={buttons || []}
          breakpoint={breakpoint}
          validators={{
            text: checkButtonLayerButtonText,
            link: checkButtonLayerLink,
            theme: checkButtonLayerButtonThemeUuid,
          }}
        />
      );
    }
    case LayerField.Text: {
      return <LayerText breakpoint={breakpoint} />;
    }
    default:
      return;
  }
}

function rightComponent(i: LayerProps, extra: any) {
  const { hoverEffectOptions, animationOptions } = extra;
  switch (i?.field) {
    case LayerField.PositionOption: {
      return <PositionOption />;
    }
    case LayerField.EntraceEffect: {
      return (
        <EffectSelect
          entranceEffectOptions={animationOptions || []}
          hoverEffectOptions={hoverEffectOptions || []}
        />
      );
    }
  }
}

function layerComponent(params: LayerTemplate, extra: any) {
  const { left, right } = params;
  const leftList = left?.map((i) => (
    <span key={i.field}>{leftComponent(i, extra)}</span>
  ));
  const rightList = right?.map((i) => (
    <span key={i.field}>{rightComponent(i, extra)}</span>
  ));
  return {
    left: leftList,
    right: rightList,
  };
}

export default layerComponent;
